import React from "react";
import styled from "styled-components";
import checked_icon from "assets/img/checked_light.svg";
import {uniqueId} from "lodash";

interface ICheckbox {
	readonly onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	readonly children: React.ReactNode;
	readonly name: string;
	readonly id?: string;
	readonly tick_position?: string;
	readonly type?: string;
	readonly is_radio?: boolean;
	readonly width?: string;
	title?: string;
	required?: boolean;
	value?: string | number;
}

const StyledCheckbox = styled.div`
	margin: 10px auto;
	width: 100%;
	overflow: hidden;
	position: relative;
	min-height: 25px;
`;

interface ICheckboxStyled {
	readonly tick_position?: string;
}

const Checkbox = styled.input`
	position: absolute;
	${({tick_position}: ICheckboxStyled) => tick_position}: 0;
	z-index: 0;
	opacity: 0;
`;

interface ILabel extends ICheckboxStyled {
	readonly is_radio?: boolean;
	readonly width?: string;
}

const Label = styled.label`
	padding-${({tick_position}: ILabel) => tick_position}: 2.7em;
	position: relative;
	line-height: 20px;
	font-size: 14px;
	color: #000;
	vertical-align: baseline;
	text-align: left;
	box-sizing: border-box;
	width: 100%;
	display: inline-block;
	font-family: 'Roboto', sans-serif;

	a {
		text-decoration: underline;
	}

	${({is_radio}: ILabel) =>
		is_radio
			? `
		display: inline-flex;
		align-items: center;
	`
			: ""}
	&:before {
		position: absolute;
		${({tick_position}: ILabel) => tick_position}: 0;
		top: 1px;
		display: block;
		content: '';
		border: 2px solid #999898;
		width: 20px;
		height: 20px;
		box-sizing: border-box;
		background-color: transparent;

		${Checkbox}:checked + & {
			background-image: url(${checked_icon});
			background-size: 1em;
			background-repeat: no-repeat;
			background-position: center;
			background-color: var(--primaryColor);
			border-color: var(--primaryColor);
		}
	}
`;

export const CheckBox: React.FC<ICheckbox> = (props) => {
	const {
		onChange,
		children,
		tick_position = "right",
		type = "checkbox",
		id = uniqueId("checkbox"),
		width,
		...rest
	} = props;

	return (
		<StyledCheckbox>
			<Checkbox
				onChange={onChange}
				id={id}
				type={type}
				tick_position={tick_position}
				{...rest}
			/>
			<Label
				htmlFor={id}
				is_radio={type === "radio"}
				tick_position={tick_position}
				width={width}>
				{children}
			</Label>
		</StyledCheckbox>
	);
};

export default CheckBox;
